import { FC, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

import MatterDropdown from '../../../common/MatterDropdown'
import { QUERY_PARAMS } from '../../../../constants'

const HourlyCasesController: FC = () => {
  const { setValue, watch } = useFormContext()

  const getFilterValues = useCallback(
    (key: QUERY_PARAMS) => (key === QUERY_PARAMS.MATTER ? (watch('case')?.id ?? QUERY_PARAMS.ALL) : ''),
    [watch]
  )

  const setParams = useCallback(
    (key: QUERY_PARAMS, value: string) => {
      if (key === QUERY_PARAMS.MATTER) {
        setValue('case', value === QUERY_PARAMS.ALL ? null : { id: value, title: undefined })
      }
    },
    [setValue]
  )

  const customOnChange = useCallback(
    (option: { id: string; title?: string | null } | null) => {
      setValue(
        'case',
        option ? { id: option.id, title: option.title ?? undefined } : null
      )
    },
    [setValue]
  )

  return (
    <MatterDropdown
      label="Matter"
      sx={{ minWidth: 320 }}
      setParams={setParams}
      getFilterValues={getFilterValues}
      customOnChange={customOnChange}
    />
  )
}

export default HourlyCasesController
